import {InitPage} from "../index";

declare var $;
declare var App: any;
declare const tenantCode: string;
declare const isClientOdoo: string;

export interface OdooProgressChannelData {
    message: string;
    progress: number;
    inProgress: boolean;
    success: boolean;
    syncType?: string | number;
}

class OdooProgressUpdate {
    OdooProgressUpdateChannel: any;

    constructor() {
        var x = (typeof tenantCode === "undefined") ? "not_available" : tenantCode;
        var isClientOdood = (typeof isClientOdoo === "undefined") ? false : isClientOdoo;

        if(isClientOdood == 'true'){
            this.OdooProgressUpdateChannel = App.cable.subscriptions.create(
                {
                    channel: "Odoo::SyncProgressChannel",
                    tenant_code: x,
                    roomId: `odoo_sync_${x}`
                },
                {
                    connected() {
                        console.log("Connected to Odoo Progress Update Channel");
                    },
                    disconnected() {
                        console.log("Disconnected to Odoo Progress Update Channel");
                    },
                    received: (data: any) => this.updateProgress(data)
                }
            );
        }

    }

    updateProgress(data: OdooProgressChannelData) {
        console.log(data);
        if (this.isComparePageSync(data)) {
            this.updateCompareProgress(data);
            return;
        }
        if (data.syncType && data.syncType !== "catalog" && data.syncType !== 0) {
            return;
        }

        this.updateCatalogProgress(data);
    }

    isComparePageSync(data: OdooProgressChannelData): boolean {
        return data.syncType === "inventory_download" || data.syncType === 2 ||
            data.syncType === "inventory_sync" || data.syncType === 1 ||
            data.syncType === "undo_inventory_download" || data.syncType === 3;
    }

    updateCatalogProgress(data: OdooProgressChannelData) {
        const $odooSync = $("#odoo_sync");
        if (!$odooSync.length) {
            return;
        }

        const progress = data.progress ?? 0;
        if (data.inProgress) {
            $odooSync.show();
            $("#odoo_sync_btn").hide();
            $("#last_update").hide();
            $("#odoo_sync_progress").text(data.message);
            $odooSync.find(".progress-bar").css("width", `${progress}%`);
            $("#odooProgressLabel").text(`${progress}%`);
            return;
        }

        if (data.message == "Refreshing the page so the Items show up") {
            let _this = this;
            setTimeout(function() {
                _this.refresh();
            }, 2000);
            return;
        }

        this.refresh();
    }

    updateCompareProgress(data: OdooProgressChannelData) {
        const inSyncDialog = $("#sync-quantities-dialog").is(":visible");
        $(".currentStatusDesc_Category").text(`${data.message}`);

        if (data.message == "Before syncing, you must download the quantity. Please complete the \"Download Quantity\" first.") {
            $(".sync-actions > .previewSyncBtn").hide();
            $(".sync-actions > .odooSyncBtn").hide();
            $(".currentStatus .progress-spin").hide();
            $(".currentStatus .fail-img").hide();
            $(".currentStatusDesc_Category").css("color", "red");
            return;
        }

        const $odooQtySync = $("#odoo_qty_sync");
        const progress = data.progress ?? 0;
        if ($odooQtySync.length && data.inProgress) {
            $odooQtySync.show();
            $("#odoo_qty_sync_progress").text(data.message);
            $odooQtySync.find(".odoo-qty-progress-bar").css("width", `${progress}%`);
            $("#odooQtyProgressLabel").text(`${progress}%`);
        }

        if (data.message == "Preview successfully generated" && inSyncDialog) {
            $(".sync-actions > .previewSyncBtn").removeAttr("disabled");
            $(".sync-actions > .odooSyncBtn").removeAttr("disabled");
            $(".currentStatus .progress-spin").hide();
            $(".currentStatus .fail-img").hide();
            $(".currentStatus .success-img").removeClass("hide").show();
            return;
        }

        if (data.message == "Matching 100%, no discrepancies detected") {
            $(".sync-actions > .previewSyncBtn").hide();
            $(".sync-actions > .odooSyncBtn").hide();
            $(".currentStatus .progress-spin").hide();
            $(".currentStatus .success-img").removeClass("hide").show();
            $(".currentStatus .fail-img").hide();
            return;
        }

        if (data.message == "Synchronization completed") {
            $(".currentStatus .progress-spin").hide();
            $(".currentStatus .success-img").removeClass("hide").show();
            $(".currentStatus .fail-img").hide();

            if (!$odooQtySync.length && !inSyncDialog) {
                return;
            }

            let _this = this;
            setTimeout(function() {
                _this.refresh();
            }, 2000);
            return;
        }

        if (data.message == "Synchronization failed") {
            $(".currentStatus .progress-spin").hide();
            $(".currentStatus .fail-img").show();
            return;
        }

        if (data.message == "Refreshing the page so the Inventory show up") {
            $(".currentStatus .progress-spin").hide();
            $(".currentStatus .success-img").removeClass("hide").show();
            $(".currentStatus .fail-img").hide();

            if (!$odooQtySync.length && !inSyncDialog) {
                return;
            }

            let _this = this;
            setTimeout(function() {
                _this.refresh();
            }, 2000);
            return;
        }

        var bat = $(".categ_odoo_sync").length == 1;
        if (!data.inProgress && data.success && bat){
            $(".progress-spin").hide();
            $(".fail-img").hide();
            $(".doSyncBtn").hide();
            $(".odooSyncBtn").show();
            $(".odooSyncBtn").removeAttr('disabled')
            $(".previewSyncBtn").removeAttr('disabled')
            $('.success-img').removeClass("hide");
            $('.success-img').show();
            $(".currentStatusDesc_Category").text('Synchronization preview complete')
        }
        if (!data.inProgress && data.success && !bat) {
            if (!$odooQtySync.length && !inSyncDialog) {
                return;
            }
            this.refresh();
        }
        if (!data.success) {
            if (!$odooQtySync.length && !inSyncDialog) {
                return;
            }
            this.refresh();
        }
    }

    refresh(): void {
        window.location.reload();
    }
}

export function LoadPage() {
    InitPage("items", () => {
        const ts = new OdooProgressUpdate();
    });
    InitPage("compare_v2", () => {
        const t = new OdooProgressUpdate();
    });
    InitPage("print_v2", () => {
        const t = new OdooProgressUpdate();
    });
}
